exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-be812c18]{padding:0;margin:0;margin-bottom:35px;border-bottom:0}h6.head-title[data-v-be812c18]{margin-bottom:20px;font-size:1.1rem;line-height:150%}.modal-footer[data-v-be812c18]{padding:0;margin-top:18px;border:0}.form-group[data-v-be812c18]{margin-bottom:3px}.two-columns[data-v-be812c18]{-webkit-column-count:2;column-count:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-be812c18","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/employee/modals/BatchDeleteEmployeesForm.vue
// module id = Kank
// module chunks = 0